<template lang="pug">
	modal(:max-width="1600", v-if="bloque")
		.card.text-left
			.card-header
				span.fa.fa-info-circle.mr-2
				| Editor de bloques
				button.close(@click="cerrar")
					| &times;
			.card-body
				.row
					.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
						.form-group
							label Emisora
							select.form-control(v-model="bloque.emisora_ID")
								option(:value="null") Selecciona emisora
								option(:value="emisora.ID_emisora", :key="emisora.ID_emisora", v-for="emisora in listadoEmisoras") {{emisora.nombre}}

						.card
							.card-header.bg-dark.text-white
								| Bloques
								button.pull-right.btn.btn-sm.btn-warning(@click="nuevaHora")
									span.fa.fa-plus
							.table-responsive
								table.table.table-striped.m-0
									thead(v-if="bloque.horas.length > 0")
										tr
											th Hora ini
											th Hora fin
											th Bloque
											th Disparo
											th Ventana
											th Max. ins
											th
									tbody
										tr(v-for="(hora, i) in bloque.horas", :key="hora.id")
											td
												input.form-control(v-mask="'##:##:##'", v-model="bloque.horas[i].hora_inicio", placeholder="HH:MM:SS")
											td
												input.form-control(v-mask="'##:##:##'", v-model="bloque.horas[i].hora_fin", placeholder="HH:MM:SS")
											td
												select.form-control(v-model="hora.tipo_bloque", title="Tipo de bloque")
													option(:value="null") Tipo de bloque
													option(value="automatico") Automático
													option(value="manual") Manual
											td
												select.form-control(v-model="hora.tipo_disparo", title="Tipo de bloque")
													option(:value="null") Tipo de disparo
													option(value="horario") Horario
													option(value="contacto") Contacto impulsos
													option(value="manual") Manual
											td
												input.form-control(v-model.number="hora.ventana", v-mask="'##'", placeholder="15")
											td
												input.form-control(v-model.number="hora.max_inserciones", v-mask="'##'", placeholder="Ilimitado")
											td
												button.btn.btn-danger(@click="quitaHora(hora.id)")
													span.fa.fa-trash
									tbody(v-if="bloque.horas.length === 0")
										tr.bg-white
											td.text-center(colspan="7")
												.alert.alert-warning.text-center(v-if="bloque.horas.length === 0")
													| No hay horas añadidas, pulsa el botón para crearlas
					.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
						calendario-anual(:seleccion.sync="bloque.dias", :from="fechaCertificada")
			.card-footer
				button.btn.btn-primary(@click="guardar")
					span.fa.fa-save.mr-2
					| Guardar
</template>

<script>
import axios from 'axios'
import BtnDias from '../utilidades/select-dias.vue'
import CalendarioAnual from '../utilidades/calendario-anual.vue'
export default {
	components: {
		'btn-dias': BtnDias,
		'calendario-anual': CalendarioAnual
	},
	props: ['plantilla'],
	data () {
		return {
			bloque: {
				ID_bloque: null,
				emisora_ID: null,
				hora_inicio: null,
				hora_fin: null,
				programa_ID: null,
				activo: true,
				dias: [],
				horas: []
			},
			fechaCertificada: new Date(),
			anoCalendario: new Date().getFullYear(),
			festivos: new Map(),
			atajos: {
				fecha_inicio: null,
				fecha_fin: null,
				dias_semana: [],
				excluir: []
			},
			listadoEmisoras: []
		}
	},
	created () {
		axios.get('gestion-emisoras/php/api/emisoras/buscar-emisoras.php')
			.then(res => {
				this.listadoEmisoras = res.data.listado
			})
			.catch(this.$responseError)

		if (this.plantilla) {
			this.bloque = JSON.parse(JSON.stringify(this.plantilla))
		}
	},
	methods: {
		cambiaAno (ano) {
			this.anoCalendario = ano
			this.getFestivos()
		},
		nuevaHora () {
			this.bloque.horas.push({
				id: new Date().getTime(),
				hora_inicio: '',
				hora_fin: '',
				tipo_bloque: 'automatico',
				tipo_disparo: 'contacto',
				ventana: 15,
				max_inserciones: null
			})
		},
		quitaHora (id) {
			for (let i = 0; i < this.bloque.horas.length; i++) {
				if (this.bloque.horas[i].id === id) {
					this.bloque.horas.splice(i, 1)
					return
				}
			}
		},
		guardar () {
			// convertimos las fechas
			if (!this.bloque.emisora_ID) {
				this.$error('Error', 'No has seleccionado la emisora')
				return
			}
			if (this.bloque.horas.length === 0) {
				this.$error('Error', 'Debes proporcionar al menos un intérvalo de horas')
				return
			}
			if (this.bloque.dias.length === 0) {
				this.$error('Error', 'Debes seleccionar al menos un día en el calendario')
				return
			}
			const post = JSON.parse(JSON.stringify(this.bloque))
			axios.post('gestion-emisoras/php/api/bloques/generar-bloques.php', post)
				.then(res => {
					this.$store.commit('toast/success', {
						titulo: 'Bloques generados',
						mensaje: 'Se han guardado los bloques correctamente'
					})
					this.cerrar()
				})
				.catch(this.$responseError)
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-emisoras/vue/componentes/bloques/generador-bloques.vue